import { PortalTelemetryScreen } from '../../../../app/telemetry/portalTelemetryScreens';
import { portalAction, portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../app/telemetry/usePortalTelemetry';
import { Button, Grid, Typography } from "@mui/material";
import { toast } from 'react-toastify';
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { useAppDispatch, useAppSelector } from "../../../../app/store/configureStore";
import { getLocalDate, getValueFromIdList, getLocalDateInString } from "../../../../app/utils/util";
import { useForm } from "react-hook-form";
import cpdFormModel from "../../common/cpdFormModel";
import { getCpdDetailsAsync, deleteCpdDetailsAsync } from "../../../../app/slices/creditsSlice";
import { API_REQUEST_FULLFILLED, MESSAGE_PROCESSING_DETAILS, MESSAGE_DLETED_SAVED } from "../../../../app/utils/constant";
import { AppPathEnum } from "../../../../app/enums/appPathEnum";
import { useReferenceData } from "../../../../app/customHooks/useReferenceData";
import UnsavedChangesDialog from "../../../../app/components/UnsavedChangesDialog";
import { CpdStatus } from "../../../../app/models/staticData/cpdStatus";
import { VerificationStatus } from "../../../../app/models/staticData/verificationStatus";
import { useGetPcsEnrolmentYears } from "../../../../app/customHooks/useGetPcsEnrolmentYears";
import { CpdCategoryEnum } from "../../../../app/enums/cpdCategoryEnum";

export function ViewCpdRecord() {
    const {
        formField: {
            ActivityDate,
            ActivityType,
            Category,
            CreditsClaiming,
            Description,
            DevelopmentPurpose,
            Domains
        }
    } = cpdFormModel;
    const { reset } = useForm();
    const { creditRecordId } = useParams<{ creditRecordId: string }>();

    const dispatch = useAppDispatch();

    const { cpdCategories, activityTypes, cpdRecordStatuses, goodPracticeDomains, verificationStatuses, staticDataStateStatus } = useAppSelector(state => state.ReferenceData);
    const { cpdDetails, getCpdStatus, getCpdHistoryStatus, deleteCpdStateStatus } = useAppSelector(state => state.credits);
    const { enrolmentYears, enrolmentYearsStatus } = useAppSelector(state => state.pcsEnrolment);

    const [deleteCpdRecordConfirmation, setDeleteCpdRecordConfirmation] = useState(false);
    const [cpdRecordStatus, setCpdRecordStatus] = useState<CpdStatus>();

    const history = useHistory();

    const [verificationStatus, setVerificationStatus] = useState<VerificationStatus | undefined>();

    useReferenceData();
    useGetPcsEnrolmentYears();

    useEffect(() => {
        if (enrolmentYears !== null &&
            cpdDetails?.activityDate !== undefined && verificationStatuses !== undefined) {
            let activityYear = new Date(cpdDetails?.activityDate.toString()).getUTCFullYear();
            const april30 = new Date(activityYear, 3, 30, 23, 59, 59, 999);
            activityYear = new Date(cpdDetails?.activityDate.toString()) <= april30 ? activityYear - 1 : activityYear;
            const verificationStatusId = enrolmentYears.find(x => x.year === activityYear)?.verificationStatusId;
            setVerificationStatus(verificationStatuses?.find(x => x.id === verificationStatusId));
        }
    }, [cpdDetails, enrolmentYears, verificationStatuses]);

    useEffect(() => {
        if (cpdDetails !== null && cpdRecordStatuses && cpdRecordStatuses.length > 0) {
            setCpdRecordStatus(cpdRecordStatuses.find(x => x.id === cpdDetails.cpdRecordStatusId));
        }
    }, [cpdDetails, cpdRecordStatuses]);

    useEffect(() => {
        if (creditRecordId !== "") {
            dispatch(getCpdDetailsAsync(creditRecordId));
        }
    }, [creditRecordId, reset, dispatch]);

    function handleDelete() {
        dispatch(deleteCpdDetailsAsync(cpdDetails?.creditRecordId!))
            .then((response: any) => {
                if (response.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                    toast.success(MESSAGE_DLETED_SAVED);
                    history.push(`${AppPathEnum.PCS_VIEW_CPDS}${window.location.search}`);
                }
            });
    }

    function getLabelFromValue(data: any, id: string) {
        return data?.filter((x: any) => x.id === id)[0]?.value;
    }

    const isDateBeforeApril2025 = (activityDate: string | undefined) => {
        if (activityDate === undefined) return false;

        const formattedActivityDate = getLocalDate(activityDate);

        return formattedActivityDate.getFullYear() < 2025
            || (formattedActivityDate.getFullYear() === 2025 &&
                formattedActivityDate.getMonth() <= 3)
    }

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), undefined, !((getCpdStatus === ApiRequestStatus.Pending || staticDataStateStatus === ApiRequestStatus.Pending ||
        deleteCpdStateStatus === ApiRequestStatus.Pending || getCpdHistoryStatus === ApiRequestStatus.Pending ||
        enrolmentYearsStatus === ApiRequestStatus.Pending)));

    if (getCpdStatus === ApiRequestStatus.Pending || staticDataStateStatus === ApiRequestStatus.Pending ||
        deleteCpdStateStatus === ApiRequestStatus.Pending || getCpdHistoryStatus === ApiRequestStatus.Pending ||
        enrolmentYearsStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <>
        <Grid container rowSpacing={2}>

            <Grid size={{ xs: 12, sm: 12 }}>
                <Button variant="contained" component={Link} to={`${AppPathEnum.PCS_VIEW_CPDS}`} color='primary' onClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.navigate`, () => { })}>
                    Search CPD records
                </Button>
            </Grid>

            <Grid size={{ sm: 5 }}></Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 7 }}><Typography variant='h4'>View CPD record</Typography></Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
                <b>{ActivityDate.label.replace("*", "")}</b>
            </Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {cpdDetails && getLocalDateInString(new Date(cpdDetails?.activityDate))}
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
                <b>{Category.label.replace("*", "")}</b>
            </Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {cpdDetails && cpdCategories && getLabelFromValue(cpdCategories, cpdDetails?.cpdCategoryId)}
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}><b>{ActivityType.label.replace("*", "")}</b></Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {cpdDetails && activityTypes && getLabelFromValue(activityTypes, cpdDetails?.activityTypeId)}
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}><b>{Domains.label.replace("*", "")}</b></Grid>
            <Grid size={{ xs: 0.5 }}></Grid>
            <Grid size={{ xs: 12, sm: 8.5 }}>
                <ul>
                    {cpdDetails && goodPracticeDomains && getValueFromIdList(goodPracticeDomains ?? [],
                        cpdDetails?.goodPracticeDomainIds!).map(function (name, index) {
                            return <li key={index}>{name}</li>
                        })}
                </ul>
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}><b>{CreditsClaiming.label.replace("*", "")}</b></Grid>
            <Grid size={{ xs: 0.5 }}></Grid>
            <Grid size={{ xs: 12, sm: 8.5 }}>{cpdDetails?.credits}</Grid>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}><b>{Description.label.replace("*", "")}</b></Grid>
            <Grid size={{ xs: 0.5 }}></Grid>
            {cpdCategories?.find(x => x.id === cpdDetails?.cpdCategoryId)?.code !== CpdCategoryEnum.AnnualPlan &&
                <Grid size={{ xs: 12, sm: 8.5 }}>
                    {cpdDetails?.description}
                </Grid>
            }

            {cpdCategories?.find(x => x.id === cpdDetails?.cpdCategoryId)?.code === CpdCategoryEnum.AnnualPlan &&
                <Grid size={{ xs: 12, sm: 8.5 }} sx={{ color: 'primary.main' }}>
                    <b>To view/edit  your Annual PCS Plan - go back to the PCS Home Page and click on the PCS Plan tile.</b>
                </Grid>
            }

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12, sm: 3 }}><b>{DevelopmentPurpose.label.replace("*", "")}</b></Grid>
            <Grid size={{ xs: 0.5 }}></Grid>
            <Grid size={{ xs: 12, sm: 8.5 }}>{cpdDetails?.purpose}</Grid>
            <Grid size={{ xs: 12 }}></Grid>

        </Grid>

        {cpdCategories?.find(x => x.id === cpdDetails?.cpdCategoryId)?.code !== CpdCategoryEnum.AnnualPlan &&
            <Grid container columns={16}>
                <Grid size={{ xs: 4, sm: 4 }}>
                    <Button variant="contained" component={Link} color='primary' sx={{ width: '90%' }}
                        to={`${AppPathEnum.PCS_UPDATE_CPD_CREDIT_RECORD}/${cpdDetails?.creditRecordId}`}
                        disabled={verificationStatus?.userEditable === false ||
                            (cpdRecordStatus && !cpdRecordStatus.userEditable) ||
                            isDateBeforeApril2025(cpdDetails?.activityDate)} onClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.navigate`, () => { })}>Edit</Button>
                </Grid>

                <Grid size={{ xs: 1, sm: 0.5 }}></Grid>

                <Grid size={{ xs: 4.5, sm: 4 }}>
                    <Button variant="contained" component={Link} to={`${AppPathEnum.PCS_CLONE_CPD_CREDIT_RECORD}/${cpdDetails?.creditRecordId}`}
                        color='primary' sx={{ width: '90%' }} disabled={isDateBeforeApril2025(cpdDetails?.activityDate)} onClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.navigate`, () => { })}>Clone</Button>
                </Grid>

                <Grid size={{ xs: 1, sm: 0.5 }}></Grid>

                <Grid size={{ xs: 5.5, sm: 4 }}>
                    <Button variant="contained" onClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.onClick.setDeleteCpdRecordConfirmation`, () => setDeleteCpdRecordConfirmation(true))}
                        disabled={verificationStatus?.userEditable === false ||
                            (cpdRecordStatus && !cpdRecordStatus.userEditable) ||
                            isDateBeforeApril2025(cpdDetails?.activityDate)}
                        color='primary' sx={{ width: '90%' }}>Delete</Button>
                </Grid>
            </Grid >
        }

        {deleteCpdRecordConfirmation &&
            <UnsavedChangesDialog showDialog={true}
                title={'Are you sure you want to delete CPD Record?'}
                subTitle={`Clicking yes will permanently remove this CPD record.`}
                yesButtonClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.yesButtonClick.handleDelete`, () => {
                    handleDelete();
                    setDeleteCpdRecordConfirmation(false);
                })}
                noButtonClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewCpdRecord), `${PortalTelemetryScreen.ViewCpdRecord}.noButtonClick.setDeleteCpdRecordConfirmation`, () => setDeleteCpdRecordConfirmation(false))}
                showYesNoButtons={true} />
        }
    </>
}
